import { Component,  EventEmitter,  Input, Output } from '@angular/core';
import { createId } from 'globals/helpers/helpers';
import { ImageUploaderResult } from 'globals/store/share.data';
import { ImageType } from 'globals/store/files.model';
import { ImageUploaderComponent } from '../wrappers/image-uploader.component';

@Component({
    selector: 'brand-image-text-adder',
    template: `
<image-uploader
  [displayType]="'text'"
  [id]="imageId"
  [immediate]="true"
  [maxSize]="1024*1024*maxMegs"
  [uniqueFormIdentifier]="uniqueFormIdentifier"
  [accountId]="accountId"
  [eventId]="eventId"
  (newUrls)="addImage.emit($event)"
  [type]="imageType" 
  [noThumb]="true" 
  [uploadText]="uploadText"
></image-uploader>
<div class="dimensions">{{ width }} (w) x {{ height }} (h) pixels</div>
<div class="type">JPG, PNG, GIF or SVG</div>
<div class="size">{{ maxMegs }}mb maximum</div>
`,
    styleUrls: [`./brand-image-text-adder.scss`],
    standalone: true,
    imports: [ImageUploaderComponent],
})
export class BrandImageTextAdderComponent {
  @Input() maxMegs= 2
  @Input() width: number
  @Input() height: number
  @Input() accountId: string
  @Input() eventId: string
  @Input() uploadText: string
  @Input() imageType: ImageType
  @Input() uniqueFormIdentifier: string
  @Output() addImage: EventEmitter<ImageUploaderResult> = new EventEmitter()

  imageId = createId()
  mobileId = createId()


}

